import axios from 'axios'
import router from '../router/index'
import { Toast } from 'vant';
// let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
// let token = loginInfo.access_token;
// let token = '';
 
axios.defaults.withCredentials = false;
// axios.defaults.headers.common['token'] = token;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';//配置请求头


 
// http request拦截器 添加一个请求拦截器
axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token");
    let getuuid = localStorage.getItem('uid');
    if (token) {
        
        //将token放到请求头发送给服务器,将tokenkey放在请求头中
        config.headers.Authorization = token;
        // config.headers.Authorization = 'hduashduashdiusahdiuah';
        config.headers.uuid = getuuid;
        //也可以这种写法
        // config.headers['token'] = token;
    }
 return config;
}, function (error) {
    Toast.fail('请求超时');
    // Do something with request error
    return Promise.reject(error);
});
 
// 添加一个响应拦截器
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    // error.response.data.message=="登录状态已失效" && 
    if (error.response.data.code == '403') {
        Toast.fail("登录信息已失效，请重新登录");
        // localStorage.setItem('isLogin' , false)
        localStorage.clear();
        router.push('/login');
    }else{
        Toast.fail(error.response.data.message);
    } 
    return Promise.reject(error);
})
 
// let base = 'http://123.56.253.83:7002/api/v1/';
// let publicApiBase = 'http://123.56.253.83:7000/';
// let base = 'http://buyer-api.test.786shop.qiawei.com/api/v1/';
// let publicApiBase = 'http://base-api.test.786shop.qiawei.com/';
let base = 'https://buyer-api.jiuleimall.com/api/v1/';
let publicApiBase = 'https://base-api.jiuleimall.com/';

//通用方法
export const POST = (url, params) => {
    // const getTimestamp = new Date().getTime();
    // return axios.post(`${base}${url}?timer=${getTimestamp}`, params).then(res => res.data)
    // return axios.post(`${base}${url}`, params).then(res => res.data)
    return axios({
        method: 'post',
        url: `${base}${url}`,
        params
    })
}
 
export const GET = (url, params) => {
    // const getTimestamp = new Date().getTime();
    // return axios.get(`${base}${url}?timer=${getTimestamp}`, { params: params }).then(res => res.data)
    // return axios.get(`${base}${url}`, { params: params }).then(res => res.data)
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params
    })
}
export const publicGET = (url, params) => {
    // const getTimestamp = new Date().getTime();
    // return axios.get(`${base}${url}?timer=${getTimestamp}`, { params: params }).then(res => res.data)
    // return axios.get(`${base}${url}`, { params: params }).then(res => res.data)
    return axios({
        method: 'get',
        url: `${publicApiBase}${url}`,
        params
    })
}
 
export const PUT = (url, params) => {
    // return axios.put(`${base}${url}`, params).then(res => res.data)
    return axios({
        method: 'put',
        url: `${base}${url}`,
        params
    })
}
 
export const DELETE = (url, params) => {
    // return axios.delete(`${base}${url}`, { params: params }).then(res => res.data)
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        params
    })
}
 
export const PATCH = (url, params) => {
    return axios.patch(`${base}${url}`, params).then(res => res.data)
}